(() => {
  function pageUrl() {
    return `${window.location.origin}${window.location.pathname}`;
  }

  async function copyLink(url) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return;
    }
    const field = document.createElement('textarea');
    field.value = url;
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('copy unavailable');
  }

  function initialize(root) {
    if (root.dataset.quickShareReady) return;
    root.dataset.quickShareReady = 'true';
    const status = root.querySelector('.quick-share__status');
    const title = root.dataset.shareTitle || document.title;
    const whatsapp = root.querySelector('.quick-share__button--whatsapp');
    if (whatsapp) whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${title} ${pageUrl()}`)}`;

    root.querySelector('.quick-share__button--native')?.addEventListener('click', async () => {
      status.textContent = '';
      if (navigator.share) {
        try {
          await navigator.share({ title, url: pageUrl() });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await copyLink(pageUrl());
        status.textContent = root.dataset.copiedLabel;
      } catch (_) {
        status.textContent = root.dataset.copyErrorLabel;
      }
    });

    root.querySelector('.quick-share__button--copy')?.addEventListener('click', async () => {
      try {
        await copyLink(pageUrl());
        status.textContent = root.dataset.copiedLabel;
      } catch (_) {
        status.textContent = root.dataset.copyErrorLabel;
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll('.quick-share').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
